import { IDataSourceItem } from 'Modules/Studio/DataSources/redux/initialState';
import { ILogSummaryItem } from '../constants/ingestionLog.interface';
import { getValidLogs } from './getValidLogs';

export const getSummaryStatus = (
  list: Record<'used' | 'unUsed', IDataSourceItem[]> | undefined,
  logs: ILogSummaryItem[] | undefined
): (IDataSourceItem & { status?: number })[] => {
  if (!list || !list?.used) return [];
  const { validLogs } = getValidLogs(logs || [], list);
  // Combine the list with the valid logs
  const combinedList = list.used.map((item) => {
    if (validLogs && validLogs.has(item.name)) {
      return {
        ...item,
        status: validLogs.get(item.name)?.status,
        startTime: validLogs.get(item.name)?.startTime,
      };
    }
    return item;
  });
  return combinedList;
};
